import clsx from 'clsx'
import { FC } from 'react'

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  variant?: 'solid' | 'outline'
  isCell?: boolean
}

const Textarea: FC<TextareaProps> = ({ variant = 'solid', isCell, ...props }) => {
  return (
    <textarea
      {...props}
      className={clsx(
        'form-control flex-grow-1 mb-3 mb-lg-0',
        {
          'form-control-solid': variant === 'solid',
        },
        props.className
      )}
      disabled={props.disabled}
    ></textarea>
  )
}

export { Textarea }
